import {
  FreeMetaTransactionsActionTypes,
  FETCH_FREE_META_TRANSACTIONS,
  FETCH_FREE_META_TRANSACTIONS_SUCCESS,
  FETCH_FREE_META_TRANSACTIONS_ERROR,
} from '../../types/actions/FreeMetaTransactions.actions';
import {IFreeMetaTransactions} from '../../types/models/FreeMetaTransactions';

export interface FreeMetaTransactionsState {
  data: IFreeMetaTransactions | null;
  isLoading: boolean;
}

const initialState: FreeMetaTransactionsState = {
  isLoading: false,
  data: null,
};

export default (
  state = initialState,
  action: FreeMetaTransactionsActionTypes,
): FreeMetaTransactionsState => {
  switch (action.type) {
    case FETCH_FREE_META_TRANSACTIONS: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case FETCH_FREE_META_TRANSACTIONS_SUCCESS: {
      return {
        isLoading: false,
        data: action.payload,
      };
    }
    case FETCH_FREE_META_TRANSACTIONS_ERROR: {
      return {
        isLoading: false,
        data: null,
      };
    }
    default:
      return state;
  }
};
